export const chunk = (arr, n) => {
  if (!arr.length) return [];
  return [arr.slice(0, n)].concat(chunk(arr.slice(n), n));
};

export const urlify = (str, url) =>
  str.replace(/#(\S*)/g, `<a href="${url}$1">#$1</a>`);

export const isImageLoaded = image => {
  if (!image) {
    return Promise.reject(new Error('No image detected'));
  } else if (typeof image === 'string') {
    // create an <img> from a string, treat it like a src
    const src = image;
    image = new Image();
    image.src = src;
  } else if (image.tagName !== 'IMG') {
    return Promise.reject(new Error('No image detected'));
  }
  return new Promise(resolve => {
    if (image.naturalWidth) {
      // If the browser can determine the naturalWidth the
      // image is already loaded successfully
      resolve({ image, status: 'ok' });
    } else if (image.complete) {
      // If the image is complete but the naturalWidth is 0
      // it is probably broken
      resolve({ image, status: 'error' });
    } else {
      image.onload = () => resolve({ image, status: 'ok' });
      image.onerror = () => resolve({ image, status: 'error' });
    }
  });
};

export const preloadImage = url => {
  try {
    const img = new Image();
    img.src = url;
  } catch (e) {}
};

export const merge = (...objects) => Object.assign({}, ...objects);

export const flatEqual = (obj1, obj2) =>
  JSON.stringify(obj1) === JSON.stringify(obj2);

export const toJSON = str => {
  try {
    const o = JSON.parse(str);
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (error) {
    // do nothing
  }
  return false;
};

export const encodeData = obj =>
  Object.keys(obj)
    .map(key => [key, obj[key]].map(encodeURIComponent).join('='))
    .join('&');

export const splitByCondition = (fn, arr) =>
  arr.reduce(
    ([Truthy, Falsy], x, i, arr) => {
      if (fn(x, i, arr) === false) return [Truthy, [...Falsy, x]];
      else return [[...Truthy, x], Falsy];
    },
    [[], []]
  );

export const uniqueId = () => Math.floor(new Date().valueOf() * Math.random());

export const secToHHMMSS = seconds =>
  [
    parseInt(seconds / 60 / 60, 10),
    parseInt((seconds / 60) % 60, 10),
    parseInt(seconds % 60, 10),
  ]
    .join(':')
    .replace(/\b(\d)\b/g, '0$1');

export const isWebAudioAPISupported = () =>
  window.AudioContext ||
  window.webkitAudioContext ||
  window.mozAudioContext ||
  window.oAudioContext ||
  window.msAudioContext;

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

export const loadImages = async imageUrlArray => {
  const promiseArray = []; // create an array for promises
  const imageArray = []; // array for the images

  for (const imageUrl of imageUrlArray) {
    promiseArray.push(
      new Promise(resolve => {
        const img = new Image();
        // if you don't need to do anything when the image loads,
        // then you can just write img.onload = resolve;

        img.onload = function () {
          // do stuff with the image if necessary

          // resolve the promise, indicating that the image has been loaded
          resolve();
        };

        img.src = imageUrl;
        imageArray.push(img);
      })
    );
  }
  await Promise.all(promiseArray); // wait for all the images to be loaded
  return imageArray;
};
